/**
* popup status 相关，具体可以参考 https://bytedance.feishu.cn/docs/doccn8lOAQ09Pw7OtbAJsqyb94g
*/
import * as types from 'src/store/types';
import { getNotificationStatus, updateNotificationStatus } from 'src/service/simplifiedSmb';
import { popupType } from 'src/const/account';

const contract = {
  namespaced: true,
  state: {
    popupStatusMap: {},
  },
  getters: {
    hasPostInvoiceConfirm: state => state.popupStatusMap[popupType.POST_INVOICE_CONFIRM] || false,
  },
  mutations: {
    [types.SET_POPUP_STATUS_MAP](state, data) {
      state.popupStatusMap = { ...state.popupStatusMap, ...data };
    },
  },

  actions: {
    async fetchPopupStatus({ commit, state }, keyArr) {
      if (!keyArr?.length) return;
      const { data } = await getNotificationStatus(keyArr);
      const initArr = keyArr.map(() => false);
      const showMap = data?.if_shown;
      if (showMap) {
        Object.entries(showMap).forEach(([key, val]) => {
          showMap[key] = val === 0;
          initArr[keyArr.findIndex(k => k === key)] = val === 0;
        });
        commit(types.SET_POPUP_STATUS_MAP, showMap);
      }
      return initArr;
    },

    async updatePopupStatus({ commit, state }, keys) {
      commit(types.SET_POPUP_STATUS_MAP, {
        ...keys.reduce((total, key) => {
          total[key] = true;
          return total;
        }, {}),
      });
      updateNotificationStatus(keys);
    },
  },
};

export default contract;
